<template>
  <div class="restricted">

    <div class="bg-primary-light q-mb-lg" style="border-radius: 50%; padding: 1.5em;">
      <q-icon name="sym_r_lock_person" size="4.5em" color="primary" />
    </div>

    <h3>You're on a managed program.</h3>
    <div class="q-mt-xs q-mb-md" style="font-size: 1.1em">{{ text }}</div>

    <q-btn
        @click="() => promptEmail()"
        label="Email Account Manager"
        color="primary"
        class="q-mt-lg"
        icon="sym_r_mail"
    />
  </div>
</template>

<script>
export default {
  name: "ManagedAccessRestricted",
  props: {
    homeDestination: {
      type: String,
      required: false,
      default: "/"
    },
    text: {
      type: String,
      default: "Email your account manager for any changes."
    }
  },
  methods: {
    promptEmail() {
      window.open("mailto:austin@jumpfeed.com", "_blank");
    }
  }
};
</script>

<style scoped lang="scss">
.restricted {
  @include display-flex(column, center, center);
  @include fullscreen-height-w-dual-titlebar();
}
</style>
